<cft-holy-grail-grid *transloco="let t">
  @if ({industries: industriesStatic$ | async, offerings: top10Offerings$ | async}; as sideCtx) {
    <cft-holy-grail-grid-col-left>
      <cft-holy-grail-sticky-wrapper>
        <div class="space-y-xl">
          @if (sideCtx.industries?.length) {
            <bgo-sidenav-industries [industries]="sideCtx.industries" />
          }
          @if (sideCtx.offerings?.length) {
            <bgo-sidenav-offerings [offerings]="sideCtx.offerings" />
          }
          <bgo-sidenav-direct-links />
        </div>
      </cft-holy-grail-sticky-wrapper>
    </cft-holy-grail-grid-col-left>
  }
  <cft-holy-grail-grid-content>
    <div class="plot-lg md:col-span-full">{{ t('proDirectoryPage.header.plot') }}</div>
    <h1 class="inline-block heading-2xl">
      {{ t('proDirectoryPage.header.title') }}
    </h1>

    <bgo-industries-and-offerings
      class="mt-xl"
      [industries]="industries$ | async"
      (sortingChanged)="proDirectoryPageService.refresh($event)"
    ></bgo-industries-and-offerings>

    @if (page$ | async; as page) {
      <div class="mt-2xl space-y-3xl md:mt-3xl md:space-y-20">
        @for (section of page.content; track $index) {
          @if (section.__type === 'ReviewSection') {
            <bgo-reviews-section
              [reviewSection]="section"
              (buttonClicked)="navigateToAboutUsPage()"
            ></bgo-reviews-section>
          }
          @if (section.__type === 'KnowledgeSection') {
            <bgo-knowledge-section [knowledgeSection]="section"></bgo-knowledge-section>
          }
          @if (section.__type === 'PromotionalBannerSection') {
            <bgo-promotional-banner-section [section]="section"></bgo-promotional-banner-section>
          }
          @if (section.__type === 'InspirationSection') {
            <bgo-inspiration-section [inspirationSection]="section"></bgo-inspiration-section>
          }
          @if (section.__type === 'SignupSection') {
            <bgo-lead-signup-banner [section]="section"></bgo-lead-signup-banner>
          }
        }
      </div>
    }
  </cft-holy-grail-grid-content>
</cft-holy-grail-grid>

<bgo-sticky-bottom-navigation [class.sticky-navigation-show]="showStickyFooter"></bgo-sticky-bottom-navigation>
